<template>
  <main>
    <div class="d-table margin-t-large bg-white mx-auto fit-width d-table mx-auto">
      <h1 class="font-heading-1 font-black font-family-concended font-all-upper">FREQUENTLY ASKED QUESTIONS</h1>
      <div class="underlined darkgreen"></div>
    </div>
    <div class="container margin-t-large pt-0 about">
      <div class="accordion">
        <div class="accordion-item" v-for="(faq,i) in faqs">
          <div class="faq-accordion-header accordion-header" role="button" :aria-controls="`faq-accordian-${i}`" aria-expanded="false">
            <h2>{{faq.q}}</h2>
          </div>
          <div :id="`faq-accordian-${i}`" class="faq-accordion-body accordion-body accordion-body2" role="tabpanel">
            <div class="border-top-solid"></div>
            <p v-html="faq.a" v-if="!faq.array"></p>
            <ul v-else>
                <li v-for="faq in faq.a" v-html="faq"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import faqs from "../assets/documents/FAQs.json"
  export default {
    data(){
      return{
        faqs : faqs.data
      }
    },
    mounted() {
      const accordionItem = document.querySelectorAll(".accordion-item");
      const onClickAccordionHeader = e => {
        if (e.currentTarget.parentNode.classList.contains("active")) {
          e.currentTarget.parentNode.classList.remove("active");
          e.currentTarget.setAttribute("aria-expanded" , "false")
        } else {
          Array.prototype.forEach.call(accordionItem, e => {
            e.classList.remove("active");
          });
          e.currentTarget.parentNode.classList.add("active");
          if(e.currentTarget.parentNode.getAttribute("aria-expanded") === 'true'){
            e.currentTarget.setAttribute("aria-expanded" , "false")
          }else{
            e.currentTarget.setAttribute("aria-expanded" , "true")
          }
        }
      };

      const init = () => {
        Array.prototype.forEach.call(accordionItem, e => {
          e.querySelector(".accordion-header").addEventListener(
            "click",
            onClickAccordionHeader,
            false
          );
        });
      };

      document.addEventListener("DOMContentLoaded", init);
    }
  };
</script>